
import React from 'react';
import { Language, Plan } from '../../types';
import { TRANSLATIONS } from '../../constants';
import PlanCard from './PlanCard';

interface PlansListProps {
  language: Language;
  plans: Plan[];
  expandedPlan: string | null;
  setExpandedPlan: (id: string | null) => void;
}

const PlansList: React.FC<PlansListProps> = ({ language, plans, expandedPlan, setExpandedPlan }) => {
  const t = TRANSLATIONS[language];

  return (
    <>
      <div className="flex items-center gap-4 mb-8 opacity-50">
        <div className="h-px bg-slate-300 dark:bg-white/10 flex-1"></div>
        <span className="text-[9px] font-black text-slate-400 uppercase tracking-widest">{t.plansDesc}</span>
        <div className="h-px bg-slate-300 dark:bg-white/10 flex-1"></div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 items-start">
        {plans.map((plan) => (
          <PlanCard 
            key={plan.id} 
            plan={plan} 
            isExpanded={expandedPlan === plan.id}
            onClick={() => setExpandedPlan(expandedPlan === plan.id ? null : plan.id)}
          />
        ))}
      </div>
    </>
  );
};

export default PlansList;
